import { ThreeEvent } from '@react-three/fiber';
import React, { useCallback } from 'react';
import { Vector3 } from 'three';
import { ISelectedProduct, ITexture } from '../../@types/ContextProviderRelated';
import { IProduct } from '../../models/standard/ProductModel';
import { useMultiSelectToggleContext } from '../../provider/MultiSelectToggleProvider';
import { useToolbarContext } from '../../provider/ToolbarProvider';
import { setItemFootprint } from '../../utils/itemFootprintRegistry';
import SVGLoader from './SVGLoader';

interface ProductProps {
  product: IProduct; 
  svgPath: string;
  position?: [number, number, number];
  length: number;
  depth: number;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  selectedProduct: ISelectedProduct;
  rotation: number;
  index: number;
  onClick: (e: ThreeEvent<PointerEvent>) => void;
  onPositionChange?: (newPosition: [number, number, number]) => void;
  onDragMove?: (newPosition: [number, number, number]) => void;
  onRotationChange?: (newRotation: number) => void;
  texture?: ITexture;
  onDragEnd?: (finalPosition: Vector3) => void;
  isGhost?: boolean; // NEW PROP
}

const Product: React.FC<ProductProps> = ({
  product,
  svgPath,
  position = [0, 0, 0],
  length,
  depth,
  fillColor,
  strokeColor,
  strokeWidth,
  selectedProduct,
  rotation,
  index,
  onClick,
  onPositionChange,
  onDragMove,
  onRotationChange,
  texture,
  onDragEnd,
  isGhost = false
}) => {
  const { interactionMode } = useToolbarContext();
  const { showRoomComponentDetails } = useMultiSelectToggleContext();
  const isSelected = selectedProduct.selectedProductIndex === index;
  const handleFootprintChange = useCallback(({ width, length: footprintLength }: { width: number; length: number }) => {
    setItemFootprint(product, { width, length: footprintLength });
  }, [product]);

  return (
    <SVGLoader
      svgPath={svgPath}
      position={position}
      length={length}
      depth={depth}
      rotation={rotation}
      fillColor={fillColor}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      texture={texture}
      index={index}
      isSelected={isSelected}
      interactionMode={interactionMode}
      showRoomComponentDetails={showRoomComponentDetails}
      onClick={onClick}
      onPositionChange={onPositionChange}
      onDragMove={onDragMove}
      onRotationChange={onRotationChange}
      onDragEnd={onDragEnd}
      onFootprintChange={handleFootprintChange}
      isGhost={isGhost}
    />
  );
};

export default Product;
